/** @format */

import React from "react"
import { Link } from "react-router-dom"
import "./LegalPage.css"

function PrivacyPage() {
    return (
        <main className="legal-page">
            <div className="container legal-container">
                <div className="legal-card">
                    <h1 className="font-display">Политика конфиденциальности</h1>
                    <p className="legal-date">Дата публикации: 18 февраля 2026 г.</p>

                    <h2>1. Общие положения</h2>
                    <p>
                        Настоящая Политика конфиденциальности (далее — «Политика») определяет порядок
                        обработки и защиты персональных данных пользователей (далее — «Пользователь») сайта
                        «Лесной домик» (далее — «Сайт»), расположенного по адресу в сети Интернет.
                    </p>
                    <p>
                        Оператором персональных данных является ИП [ФИО], ИНН [номер], ОГРНИП [номер] (далее —
                        «Оператор»).
                    </p>
                    <p>
                        Используя Сайт и предоставляя свои персональные данные, Пользователь выражает согласие
                        с условиями настоящей Политики. В случае несогласия Пользователь должен прекратить
                        использование Сайта.
                    </p>

                    <h2>2. Персональные данные, которые мы собираем</h2>
                    <p>При оформлении бронирования мы собираем следующие данные:</p>
                    <ul>
                        <li>Имя (фамилия, имя)</li>
                        <li>Номер телефона</li>
                        <li>Количество гостей</li>
                        <li>Даты заезда и выезда</li>
                        <li>Комментарий к бронированию (при наличии)</li>
                    </ul>
                    <p>
                        При оплате услуг платёжные данные (номер карты, срок действия и т.д.) обрабатываются
                        исключительно платёжным сервисом ЮKassa (ООО «ЮМани», ИНН 7736641890) и не передаются
                        Оператору.
                    </p>

                    <h2>3. Цели обработки персональных данных</h2>
                    <p>Ваши данные обрабатываются в следующих целях:</p>
                    <ul>
                        <li>Оформление и подтверждение бронирования</li>
                        <li>Связь с Пользователем для уточнения деталей бронирования</li>
                        <li>Расчёт стоимости услуг</li>
                        <li>Приём и обработка оплаты</li>
                        <li>Уведомление Оператора о новых бронированиях</li>
                        <li>Исполнение обязательств по договору-оферте</li>
                        <li>Соблюдение требований законодательства РФ</li>
                    </ul>

                    <h2>4. Правовые основания обработки</h2>
                    <p>Обработка персональных данных осуществляется на основании:</p>
                    <ul>
                        <li>Согласия Пользователя (п. 1 ч. 1 ст. 6 Федерального закона № 152-ФЗ)</li>
                        <li>
                            Исполнения договора, стороной которого является Пользователь (п. 5 ч. 1 ст. 6
                            152-ФЗ)
                        </li>
                        <li>Необходимости исполнения законных обязанностей Оператора</li>
                    </ul>

                    <h2>5. Передача данных третьим лицам</h2>
                    <p>Персональные данные могут быть переданы следующим третьим лицам:</p>
                    <ul>
                        <li>
                            <strong>ЮKassa (ООО «ЮМани»)</strong> — для обработки платежей. Политика
                            конфиденциальности:{" "}
                            <a
                                href="https://yoomoney.ru/page?id=523014"
                                target="_blank"
                                rel="noopener noreferrer">
                                yoomoney.ru
                            </a>
                        </li>
                        <li>
                            <strong>Telegram (Telegram FZ-LLC)</strong> — для отправки уведомлений Оператору о
                            новых бронированиях (передаётся имя, телефон, даты, сумма)
                        </li>
                    </ul>
                    <p>
                        Оператор не продаёт и не передаёт персональные данные иным третьим лицам, за
                        исключением случаев, предусмотренных законодательством РФ.
                    </p>

                    <h2>6. Хранение и защита данных</h2>
                    <p>
                        Персональные данные хранятся на защищённых серверах на территории Российской
                        Федерации. Срок хранения — в течение 3 (трёх) лет с момента последнего бронирования
                        или до момента отзыва согласия Пользователем.
                    </p>
                    <p>
                        Для защиты данных применяются организационные и технические меры, включая шифрование
                        при передаче (HTTPS/TLS), ограничение доступа к базе данных, парольную защиту
                        административной панели.
                    </p>

                    <h2>7. Права Пользователя</h2>
                    <p>Пользователь имеет право:</p>
                    <ul>
                        <li>Получить информацию об обработке своих персональных данных</li>
                        <li>Требовать уточнения, блокирования или уничтожения своих данных</li>
                        <li>Отозвать согласие на обработку персональных данных</li>
                        <li>Обжаловать действия Оператора в Роскомнадзор</li>
                    </ul>
                    <p>
                        Для реализации своих прав Пользователь может обратиться к Оператору по контактным
                        данным, указанным в разделе 10 настоящей Политики.
                    </p>

                    <h2>8. Файлы cookie</h2>
                    <p>
                        Сайт может использовать файлы cookie для обеспечения корректной работы. Файлы cookie
                        не содержат персональных данных. Пользователь может отключить cookie в настройках
                        своего браузера, однако это может повлиять на функциональность Сайта.
                    </p>

                    <h2>9. Изменения Политики</h2>
                    <p>
                        Оператор оставляет за собой право вносить изменения в настоящую Политику. Новая
                        редакция Политики вступает в силу с момента её размещения на Сайте. Продолжение
                        использования Сайта после внесения изменений означает согласие Пользователя с новой
                        редакцией.
                    </p>

                    <h2>10. Контакты</h2>
                    <p>По вопросам обработки персональных данных обращайтесь:</p>
                    <ul>
                        <li>
                            Телефон: <a href="tel:+79153663735">+7 915 366 37 35</a>
                        </li>
                        <li>
                            Email: <a href="mailto:matinyan.lilit@mail.ru">matinyan.lilit@mail.ru</a>
                        </li>
                    </ul>

                    <Link to="/" className="btn-outline legal-back">
                        ← На главную
                    </Link>
                </div>
            </div>
        </main>
    )
}

export default PrivacyPage
